import { Group, Text, Tooltip } from '@mantine/core';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './MintStatus.module.css';

export const getTypeColor = (type: string) => {
	switch (type) {
		case 'success':
			return classes.successColor;
		case 'warning':
			return classes.warningColor;
		case 'error':
			return classes.errorColor;
		default:
			return classes.defaultColor;
	}
};

export const MintStatus = (props: {
	children: ReactNode;
	type: string;
}) => {
	const { t } = useTranslation();
	return (
		<Tooltip
			label={
				props.children == 'Minted' &&
				t(`global.toolipMinted`)
			}
			disabled={props.children !== 'Minted'}
		>
			<Group gap="4px">
				{props.type && (
					<Text
						className={clsx(
							classes.dot,
							getTypeColor(props.type)
						)}
					>
						●
					</Text>
				)}
				<Text
					className={clsx(
						classes.text,
						getTypeColor(props.type)
					)}
				>
					{t(`global.${props.children}`)}
				</Text>
			</Group>
		</Tooltip>
	);
};
